export const utmMedium = 'referral';
export const utmSource = 'tunein.com';
export const utmCampaignSidebar = 'sidebar_gemini_redirect';
export const utmCampaignLandingPage = 'gemini_homepage';
export const utmCampaignPaymentCompletePage = 'gemini_payment_complete_page';
